import * as React from "react";

function SvgMoveToLoadPort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M2.833 0L0 2.833l4.25 4.25-2.833 2.834h8.5v-8.5L7.083 4.25 2.833 0zM11.333 16.485v3.09H34v-3.09H11.333zM15.454 27.818l7.213-7.212 7.212 7.212h-5.152V34h-4.12v-6.182h-5.152zM12.364 15.454H32.97l-4.121-4.12H16.485l-4.121 4.12z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgMoveToLoadPort;
